<template>
  <div>

    <div v-if="!form.carts.length" class="no-prod-msg">
      <EmptyCartImage>
        <el-button type="primary" size="large" @click="handleGoHome">
          {{ t("carts.continueShopping") }}
        </el-button>
      </EmptyCartImage>
    </div>
    <div v-else class="w-100">
      <el-form
        ref="ruleFormRef"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="120px"
    	>
        <div class="col-12 no-padding-xs">
          <CartEventItems
            v-model:state="state"
            v-model:data="data"
            v-model:form="form"
            :cart-event-groups-formatted="cartEventGroupsFormatted"
            @delete="deleteCart"
            @change="changeQty"
          ></CartEventItems>

          <PaymentInfo
            v-model="form"
            :available-payment-types="availablePaymentTypes"
          ></PaymentInfo>

          <CoinDiscount
            v-if="data.enable_coin_discount"
            v-model="form"
            :data="data"
            :coin-discount-limit="coinDiscountLimit"
          ></CoinDiscount>

          <BuyerInfo v-model="form"></BuyerInfo>

          <ToInfo v-model="form" :show-to-info="state.showToInfo">
            <div>
              <el-checkbox
                v-model="state.showToInfo"
                size="large"
              >
                {{ t("carts.differentBuyer") }}
              </el-checkbox>
            </div>
            <!-- 宅配 -->
            <ToHome
              ref="homeRef"
              v-model="form"
              v-model:state="state"
              :used-logistic-types="usedLogisticTypes"
              :provice-map="proviceMap"
              show-uads
            />
            <!-- 711門市 -->
            <ToCvs711
              ref="cvsPcscRef"
              v-model:form="form"
              v-model:state="state"
              :used-logistic-types="usedLogisticTypes"
              show-uads
            />
            <!-- 全家門市 -->
            <ToCvsFamily
              ref="cvsFamilyRef"
              v-model:form="form"
              v-model:state="state"
              :used-logistic-types="usedLogisticTypes"
              show-uads
            />

          </ToInfo>

          <InsuranceFeesCheck
            v-if="data.enable_insurance_fees && !!insuranceFees"
            v-model:form="form"
            v-model:state="state"
            :insurance-assort-raw-total="insuranceAssortRawTotal"
            :insurance-fees="insuranceFees"
          >
          </InsuranceFeesCheck>

          <DiscountCode
            v-model:form="form"
            :state="state"
            @ok="handleDiscountCode"
          />

          <CartGroups
            v-model:form="form"
            v-model:state="state"
            :data="data"
            :logistic-map="logisticMap"
            :cart-groups-formatted="cartGroupsFormatted"
          ></CartGroups>

          <InvoiceInfo
            v-if="showInvoice"
            v-model="form"
            :state="state"
            :provice-map="proviceMap"
            :used-logistic-types="usedLogisticTypes"
            :enableEInvoice="enableEInvoice"
            @change="handleSameHome"
          ></InvoiceInfo>

          <div class="col-12 sector memo-sector px-3">
            <div class="row">
              <div class="sector__header">
                {{ t('orders.memo') }}
                ({{ t('carts.optional') }})
              </div>
              <div class="sector__content">
                <div class="row">
                  <div class="col-12">
                    <el-input
                      v-model="form.memo"
                      :rows="3"
                      maxlength="35"
                      show-word-limit
                      type="textarea"
                      size="large"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Fixed Bottom -->
          <div class="checkout-footer-wrapper">
            <div class="checkout-footer">
              <div class="checkout-footer__left d-flex justify-content-start align-items-center flex-wrap">
                <div v-if="assortDiscount > 0" class="hidden-xs hidden-2xs">{{ t('orders.assortDiscount') }}:</div>
                <div v-if="assortDiscount > 0" class="hidden-xs hidden-2xs price">
                  -{{ state.currency_symbol }} {{ currencyFormat(assortDiscount) }}
                </div>

                <div v-if="promDiscount > 0" class="hidden-xs hidden-2xs">{{ t('orders.promDiscount') }}:</div>
                <div v-if="promDiscount > 0" class="hidden-xs hidden-2xs price">-{{ state.currency_symbol }}  {{ currencyFormat(promDiscount) }}</div>

                <div v-if="data.enable_coin_discount && form.coin_discount > 0" class="hidden-xs hidden-2xs">{{ t('orders.enable_coin_discount') }}:</div>
                <div v-if="data.enable_coin_discount && form.coin_discount > 0" class="hidden-xs hidden-2xs price">
                  -{{ state.currency_symbol }} {{ currencyFormat(form.coin_discount) }}
                </div>

                <div class="hidden-xs hidden-2xs">{{ t('orders.deliveryFees') }}:</div>
                <div class="hidden-xs hidden-2xs price">{{ state.currency_symbol }} {{ currencyFormat(deliveryFees) }}</div>

                <div v-if="deliveryFeesDiscount > 0" class="hidden-xs hidden-2xs">{{ t('orders.deliveryFeesDiscount') }}:</div>
                <div v-if="deliveryFeesDiscount > 0" class="hidden-xs hidden-2xs price">-{{ state.currency_symbol }} {{ currencyFormat(deliveryFeesDiscount) }}</div>

                <div v-if="promotionCodeDiscount > 0" class="hidden-xs hidden-2xs">{{ t('carts.useDiscountCode') }}:</div>
                <div v-if="promotionCodeDiscount > 0" class="hidden-xs hidden-2xs price">-{{ state.currency_symbol }} {{ currencyFormat(promotionCodeDiscount) }}</div>

                <div>{{ t('carts.totalItemAndTotal', [cartCount]) }}:</div>
                <div class="price">{{ state.currency_symbol }} {{ currencyFormat(cartTotal) }}</div>
              </div>

              <div class="checkout-footer__right" @click="executeSubmit(ruleFormRef)">
                {{ t("global.next") }}
              </div>

            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, watch, onMounted, toRaw } from 'vue'
import {
  _api_updateCartQty,
  _api_deleteCart,
  _api_checkoutCart,
} from "../api/index.js";
import { notificationErrors, currencyFormat, assignCartCount, clearCartCount, isBundlePromotionType } from "../utils"
import { useI18n } from "vue-i18n"
import CartEventItems from "./checkout/CartEventItems.vue"
import PaymentInfo from "./checkout/PaymentInfo.vue"
import CoinDiscount from "./checkout/CoinDiscount.vue"
import BuyerInfo from "./checkout/BuyerInfo.vue"
import ToInfo from "./checkout/ToInfo.vue"
import InsuranceFeesCheck from "./checkout/InsuranceFeesCheck.vue"
import CartGroups from "./checkout/CartGroups.vue"
import InvoiceInfo from "./checkout/InvoiceInfo.vue"
import ToHome from './checkout/ToHome.vue'
import ToCvs711 from './checkout/ToCvs711.vue'
import ToCvsFamily from './checkout/ToCvsFamily.vue'
import DiscountCode from './checkout/DiscountCode.vue'
import EmptyCartImage from "./EmptyCartImage.vue";
// import sweet_alert from '../../../src/app/static/assets/front-end/js/sweet_alert.js';

const props = defineProps({
  modelValue: Object
})

const { t, locale } = useI18n()
const data = ref(null)
const homeRef = ref()
const cvsPcscRef = ref()
const cvsFamilyRef = ref()

const TEMPERATURE_I18N = computed(() => [t("products.temperature0"), t("products.temperature1"), t("products.temperature2")]);
const ALERT_i18n = computed(() => ({
  input_error: t("errors.inputError"),
  required_login: t("errors.requiredLogin"),
  submit_error: t("errors.submitOrderError"),
}));

const cartCount = computed(() => form.carts.reduce((count, cart) => (count += cart.checked?cart.quantity:0), 0));
const showInvoice = computed(() => data.value?.country === "TW");
const promotionMap = computed(() => _.keyBy(data.value.promotions, "id"));
const logisticMap = computed(() => _.keyBy(data.value.logistics, "type"));
const hasGoogleGa = computed(() => data.value?.trackers?.ga_ids.length > 0);
const hasFacebookPixel = computed(() => data.value?.trackers?.fbq_pixel_ids.length > 0);
// 組合原始總額
const assortRawTotal = computed(() => form.carts.reduce((total, curr) => (total += curr.checked ? curr.sale_price * curr.quantity : 0), 0));
// 紅利折抵上限
const coinDiscountLimit = computed(() => {
  let limit = assortRawTotal.value - assortDiscount.value - promDiscount.value
  return data.value.account_coin > limit ? limit : data.value.account_coin
})

const handleGoHome = () => {
  window.location.href = "/"
}

// 計算任選數量
const getBundleDiscount = (promotion, carts = []) => {
  let prom_discount = 0 // 活動折扣
  const condition = promotion?.conditions?.[0]
  let obj = {
    prom_discount: formatFloat(prom_discount, data.value.currency_point),
    choose_gifts: [],
    choose_gift_qty: 0,
  }
  if (!promotion || !condition || promotion?.condition_min_type != 'qty') return obj
  let bundles = []
  let cartsCopy = _.cloneDeep(carts)
  // 1. 排序金額(大到小)
  const sortCart = [...cartsCopy.sort((a, b) => b.discounted_price - a.discounted_price)]

  // 2. 拆解單筆商品數量
  cartsCopy = []
  sortCart.forEach((cart) => {
    if (cart.checked) {
      for (let i = 0; i < cart.quantity; i++ ) {
        cartsCopy.push({...cart, quantity: 1 })
      }
    }
  })
  // 3. 組合任選條件
  let assort_total = 0, discounted_price = 0, discount_amount = 0, discountable_quantity = 0
  bundles = _.chunk(cartsCopy, condition?.min_qty)
  for (const bundle of bundles) {
    if (bundle.length != condition?.min_qty) continue
    // console.debug("bundle", toRaw(bundle))
    bundle.forEach((cart) => {
      assort_total += cart.discounted_price
    })
    discounted_price += condition?.discounted_price
    discount_amount += condition?.discount_amount
    discountable_quantity += condition?.discountable_quantity
  }
  const discount_type = promotion?.discount_type
  let choose_gift_store_product_ids = []
  if (discount_type == "pricing") {
    // 固定金額
    prom_discount += assort_total - discounted_price
  } else if (discount_type == 'amount') {
    prom_discount = discount_amount
  } else if (discount_type == 'percentage') {
    prom_discount = assort_total * (condition.discount_percentage / 100)
  } else if (discount_type == 'gift') {
    choose_gift_store_product_ids = condition.discountable_store_product_ids
    obj.choose_gift_qty = discountable_quantity
  }
  const promDiscountableStoreProductMap = _.keyBy(promotion.discountable_store_products, "id")
  choose_gift_store_product_ids.forEach((store_product_id) => {
    const gift = promDiscountableStoreProductMap[store_product_id.toString()]
    if (gift) {
      obj.choose_gifts.push(gift)
    }
  })
  obj.prom_discount = formatFloat(prom_discount, data.value.currency_point)
  return obj
}

const getPromotionDiscount = (promotion, assort_total, assort_count) => {
  let prom_discount = 0 // 活動折扣
  if (!promotion) return prom_discount

  let discount_type = promotion.discount_type
  let discount_value = null
  let choose_gift_store_product_ids = []
  let choose_gift_qty = 0

  // 滿額
  if (promotion.condition_min_type == 'amount') {
    promotion.conditions.forEach((condition) => {
      if (assort_total >= condition.min_amount) {
        if (discount_type == 'amount') {
          discount_value = condition.discount_amount
        } else if (discount_type == 'percentage') {
          discount_value = condition.discount_percentage
        } else if (discount_type == 'gift') {
          choose_gift_store_product_ids = condition.discountable_store_product_ids
          choose_gift_qty = condition.discountable_quantity
        }
      }
    })
  }
  // 滿件
  else if (promotion.condition_min_type == 'qty') {
    promotion.conditions.forEach((condition) => {
      if (assort_count >= condition.min_qty) {
        if (discount_type == 'amount') {
          discount_value = condition.discount_amount
        } else if (discount_type == 'percentage') {
          discount_value = condition.discount_percentage
        } else if (discount_type == 'gift') {
          choose_gift_store_product_ids = condition.discountable_store_product_ids
          choose_gift_qty = condition.discountable_quantity
        }
      }
    })
  }

  if (discount_type && discount_value) {
    if (discount_type == 'amount') {
      prom_discount = discount_value
    } else if (discount_type == 'percentage') {
      prom_discount = assort_total * (discount_value/100)
    }
  }

  const promDiscountableStoreProductMap = _.keyBy(promotion.discountable_store_products, "id")
  let choose_gifts = []
  choose_gift_store_product_ids.forEach((store_product_id) => {
      const gift = promDiscountableStoreProductMap[store_product_id.toString()]
      if (gift) {
        choose_gifts.push(gift)
      }
  })

  return {
    "prom_discount": formatFloat(prom_discount, data.value.currency_point),
    "choose_gifts": choose_gifts,
    "choose_gift_qty": choose_gift_qty,
  }
}
// 結帳總額
const cartTotal = computed(() => {
  let total = assortRawTotal.value + deliveryFees.value
    - deliveryFeesDiscount.value - form.coin_discount
    - assortDiscount.value - promDiscount.value
    - promotionCodeDiscount.value
  
  return total
})

const cartEventGroupsFormatted = computed(() => {
  if (!form.carts.length) {
      return {}
  }
  var start = 0;
  var end = 0;
  start = new Date().getTime();

  const grouped = _.groupBy(form.carts, (cart) => {
    return cart.event_group ? cart.event_group.event_group_uuid : null;
  })
  // console.log("by 活動: ", grouped)
  const formatted = _.reduce(
    grouped,
    (rst, val, key) => {
      // console.log("key:", key)
      // console.log("rst:", rst)
      const cartsCopy = _.cloneDeep(val)
      let cart = cartsCopy[0]
      let cart_group_name = t("carts.shoppingCart")

      let promotion = null
      if (key && cart.event_group) {
        promotion = promotionMap.value[cart.event_group.event_id]
        if (promotion) {
          cart_group_name = promotion.title
          if (promotion.min_amount_free_shipping && promotion.min_amount_free_shipping !== null) {
            cart_group_name += " (滿" + promotion.min_amount_free_shipping + "免運)"
          }
        } else {
          cart_group_name = '異常活動'
        }
      }

      let assort_count = 0 // 組合數量
      let assort_org_total = 0 // 組合 sale_price 總額
      let assort_total = 0 // 組合 discounted_price 總額
      let assort_discount = 0 // 網紅折扣
      let prom_discount = 0 // 活動折扣
      let discountable_store_product_assorts_map = promotion ? promotion.discountable_store_product_assorts_map : {}
      let choose_gifts = [] // 可選擇贈品
      let choose_gift_qty = 0 // 可選擇贈品數量

      cartsCopy.forEach(cart => {
        // console.debug("cartEventGroupsFormatted 1:", cart.cart_id, cart.discounted_price)
        // 活動價
        if (discountable_store_product_assorts_map[cart.store_assort_id]) {
          cart.discounted_price = discountable_store_product_assorts_map[cart.store_assort_id].discounted_price
        }

        // console.debug("cartEventGroupsFormatted 2:", cart.cart_id, cart.discounted_price)
        if (cart.checked) {
          assort_count += cart.quantity
          assort_org_total += cart.sale_price * cart.quantity
          assort_total += cart.discounted_price * cart.quantity
        }
      })
      assort_discount = assort_org_total - assort_total

      if (promotion) {
        let prom_discount_info = getPromotionDiscount(promotion, assort_total, assort_count)
        if (isBundlePromotionType(promotion?.type)) {
          prom_discount_info = getBundleDiscount(promotion, cartsCopy)
        }
        prom_discount = prom_discount_info.prom_discount
        choose_gifts = prom_discount_info.choose_gifts
        choose_gift_qty = prom_discount_info.choose_gift_qty
      }
      /*
      console.log('===============================')
      console.log('cart_group_name: ', cart_group_name)
      console.log('assort_count: ', assort_count)
      console.log('assort_org_total: ', assort_org_total)
      console.log('assort_total: ', assort_total)
      console.log('assort_discount: ', assort_discount)
      console.log('prom_discount: ', prom_discount)
      console.log('===============================')
      */

      rst[key] = {
        cart_group_key: key,
        cart_group_name: cart_group_name,
        items: cartsCopy,
        count: assort_count,
        assort_org_total: assort_org_total,
        assort_total: assort_total,
        assort_discount: assort_discount,
        prom_discount: prom_discount,
        prom_id: promotion?promotion.id:null,
        choose_gifts: choose_gifts,
        choose_gift_qty: choose_gift_qty,
      }

      return rst
    },
    {}
  )

  end = new Date().getTime();
  // console.debug("計算 活動: " + (end - start) / 1000 + " sec")
  // handleGroupsFormatted()

  return formatted
})
const proviceMap = computed(() => {
  if (form.country) {
    return state.countryMap?.province || {};
  }
  return {};
});

const cartGroupsFormatted = computed(() => {
  if (!form.carts.length) {
      return {}
  }
  var start = 0;
  var end = 0;
  start = new Date().getTime();
  // console.log("cartGroupsFormatted: ", data.value)
  const grouped = _.groupBy(form.carts, (cart) => {
    cart.cart_group = cart.sup_co_id + '_' + cart.logistic_type + '_' + cart.temperature;
    if (!cart.checked) {
      return "unchecked"
    }
    return cart.cart_group;
  })
  // console.log("by 物流: ", grouped)
  const formatted = _.reduce(
    grouped,
    (rst, val, key) => {
      const cartsCopy = _.cloneDeep(val)
      let count = 0
      let assort_total = 0
      let assort_org_total = 0 // 組合 sale_price 總額
      let insurance_assort_org_total = 0 // 售後保障組合原始總額

      let assort_discount = 0 // 網紅折扣
      let prom_discount = 0 // 活動折扣
      let promotion_event_ids = []
      let promotion = null

      let event_assort_map = {} // 紀錄活動組合總金額&數量
      let min_amount_free_shipping_list = [] // 免運門檻 (順序: 活動 -> 全站，取最低金額)

      cartsCopy.forEach(cart => {
        if (cart.event_group && !(promotion_event_ids.includes(cart.event_group.event_id))) {
          promotion_event_ids.push(cart.event_group.event_id)
          promotion = promotionMap.value[cart.event_group.event_id]
          // console.debug("promotion:", promotion?.is_excluded_outer_island_free_shipping)
        }
        let discountable_store_product_assorts_map = promotion ? promotion.discountable_store_product_assorts_map : {}
        // 活動價
        if (discountable_store_product_assorts_map[cart.store_assort_id]) {
          cart.discounted_price = discountable_store_product_assorts_map[cart.store_assort_id].discounted_price
        }
        count += cart.quantity
        assort_org_total += cart.sale_price * cart.quantity
        assort_total += cart.discounted_price * cart.quantity
        // console.debug("cartGroupsFormatted:", cart.cart_id, cart.discounted_price)

        // 只計算非活動的商品
        if (!cart.event_group) {
          insurance_assort_org_total += cart.sale_price * cart.quantity
        }

        if (cart.event_group && cart.event_group.event_id) {
          if (!event_assort_map[cart.event_group.event_id]) {
            event_assort_map[cart.event_group.event_id] = {
              "assort_total": 0,
              "count": 0
            }
          }
          event_assort_map[cart.event_group.event_id].assort_total += cart.discounted_price * cart.quantity
          event_assort_map[cart.event_group.event_id].count += cart.quantity
        }
      })
      assort_discount = assort_org_total - assort_total

      if (promotion_event_ids.length) {
        promotion_event_ids.forEach((event_id) => {
          let event_assort_total = event_assort_map[event_id]?event_assort_map[event_id].assort_total:0
          let event_count = event_assort_map[event_id]?event_assort_map[event_id].count:0
          let promotion = promotionMap.value[event_id]
          let prom_discount_info = getPromotionDiscount(promotion, event_assort_total, event_count)
          if (isBundlePromotionType(promotion?.type)) {
            prom_discount_info = getBundleDiscount(promotion, cartsCopy)
          }
          prom_discount += prom_discount_info.prom_discount

          let event_total = event_assort_total - prom_discount_info.prom_discount
          if (promotion.min_amount_free_shipping && promotion.min_amount_free_shipping !== null && event_total > promotion.min_amount_free_shipping) {
            min_amount_free_shipping_list.push(promotion.min_amount_free_shipping)
          }
        })
      }
      if (data.value.free_delivery_amount_limit && data.value.free_delivery_amount_limit !== null) {
        min_amount_free_shipping_list.push(data.value.free_delivery_amount_limit)
      }

      let min_amount_free_shipping = null
      if (min_amount_free_shipping_list.length > 0) {
        min_amount_free_shipping = Math.min(...min_amount_free_shipping_list)
      }

      let cart = cartsCopy[0]
      let cart_group_name = null
      if (cart.logistic_type) {
        cart_group_name = cart.sup_co_name + '。' + logisticMap.value[cart.logistic_type].name + '。' + TEMPERATURE_I18N.value[cart.temperature]
      }

      // 售後保障費
      const insurance_fees = formatFloat(insurance_assort_org_total * 0.1, data.value.currency_point)
      // console.debug("cartGroupsFormatted: ", cart)
      // console.debug("promotion:", promotion?.is_excluded_outer_island_free_shipping)
      // console.debug("min_amount_free_shipping:", assort_total, min_amount_free_shipping)
      rst[key] = {
          cart_group_key: key,
          cart_group_name: cart_group_name,
          sup_co_id: cart.sup_co_id,
          logistic_type: cart.logistic_type,
          temperature: cart.temperature,
          items: cartsCopy,
          count: count,
          assort_total: assort_total,

          assort_org_total: assort_org_total,
          assort_discount: assort_discount,
          prom_discount: prom_discount,

          delivery_fees: calcDeliveryFees(cart.logistic_type),
          delivery_fees_discount: min_amount_free_shipping !== null & assort_total >= min_amount_free_shipping
            ? calcDeliveryFees(cart.logistic_type)
            : 0,

          delivery_outer_island_fees: calcDeliveryOutIslandFees(cart.logistic_type),
          delivery_outer_island_fees_discount: !promotion?.is_excluded_outer_island_free_shipping && min_amount_free_shipping !== null & assort_total >= min_amount_free_shipping
            ? calcDeliveryOutIslandFees(cart.logistic_type)
            : 0,

          insurance_assort_org_total: insurance_assort_org_total,
          insurance_fees: insurance_fees,
      }
      return rst
    },
    {}
  );

  end = new Date().getTime();
  // console.debug("計算 物流: " + (end - start) / 1000 + " sec")

  return formatted;
});

// 網紅折扣
const assortDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    total += v.assort_discount;
  }
  return formatFloat(total, data.value.currency_point);
})

// 活動折扣
const promDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    total += v.prom_discount;
  }
  return formatFloat(total, data.value.currency_point);
})

// 運費
const deliveryFees = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    // delivery_outer_island_fees
    if (v.cart_group_key !== 'unchecked') {
      console.debug("運費:", v.logistic_type, state.isOuterIsland)
      if (state.isOuterIsland[v.logistic_type]) {
        total += v.delivery_outer_island_fees;
      } else {
        total += v.delivery_fees;
      }
    }
  }
  return formatFloat(total, data.value.currency_point);
});

// 運費折扣
const deliveryFeesDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    if (v.cart_group_key !== 'unchecked') {
      if (state.isOuterIsland[v.logistic_type]) {
        total += v.delivery_outer_island_fees_discount;
      } else {
        total += v.delivery_fees_discount;
      }
      // console.debug("運費折扣:", v)
    }
  }
  return formatFloat(total, data.value.currency_point);
});

// 品質保障費的原始商品總額
const insuranceAssortRawTotal = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    if (v.cart_group_key !== 'unchecked') {
      total += v.insurance_assort_org_total;
    }
  }
  return formatFloat(total, data.value.currency_point);
})
// 品質保障費
const insuranceFees = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    // console.log("cart_group_key: ", v.cart_group_key, v.insurance_fees)
    if (v.cart_group_key !== 'unchecked') {
      total += v.insurance_fees;
    }
  }
  // console.log("insuranceFees: ", total)
  return formatFloat(total, data.value.currency_point);
})

const usedLogisticTypes = computed(() => {
  const logistic_types = [];
  // console.log("cartGroupsFormatted: ", cartGroupsFormatted.value)
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    if (v.cart_group_key !== 'unchecked') {
      logistic_types.push(v.logistic_type);
    }
  }
  return logistic_types;
});

const enableEInvoice = computed(() => {
  // console.log("invoice_type", state.invoice_type)
  if (state.invoice_type == "ELECTRONIC") {
    return true
  }
  return false
})
const getLogisticTypess = computed(() => {
  // 檢查購物車
  const logisticTypes = []
  if (!data.value) {
    return logisticTypes
  }
  form.carts.forEach((el) => {
    if (logisticTypes.findIndex((logistic_type) => logistic_type === el.logistic_type) < 0) {
      logisticTypes.push(el.logistic_type);
    }
  });
  return logisticTypes
})

const availablePaymentTypes = computed(() => {
  if (!data.value) {
    return []
  }
  // console.log("getLogisticTypess: ", getLogisticTypess.value)

  // 檢查已選物流
  let payments = [];
  getLogisticTypess.value.forEach((logistic) => {
    const cod = logistic + ".COD"
    const paymentIndex = data.value.payments.findIndex((el) => el.type == cod)
    if (paymentIndex != -1) {
      payments.push(cod)
      // console.log(logistic, toRaw(data.value.payments[paymentIndex]));
    }
  })
  const sumPayments = [...prePayOpts.value, ...payments];
  return data.value.payments.filter((el) => sumPayments.includes(el.type) );
})

const prePayOpts = computed(() => {
  let prePay = [];

  const common = data.value.payments
    .filter((el) => (el.type.substr(-4) !== ".COD" || el.type == "ECPAY"))
    .map((el) => el.type);

  form.carts.forEach((el) => {
    const tmp = common.filter((val) => el.available_payment_types.indexOf(val) != -1)
    if (!prePay.length) {
      prePay = tmp
    } else {
      prePay = prePay.filter((val) => tmp.indexOf(val) != -1)
    }
  });
  return prePay;
})

const ruleFormRef = ref()

const form = reactive({
  // 購買者
  buyer_name: null,
  buyer_mobile: null,
  buyer_email: null,
  // 收件者
  uads_id: 0,
  to_name: null,
  to_mobile: null,
  to_email: null,
  country: null,
  province: null,
  city: null,
  region: null,
  postal_code: null,
  address: null,
  // 金流
  payment_type: availablePaymentTypes.value.length ? availablePaymentTypes.value[0].type : null,
  // 發票
  invoice_type: "invoice",
  invoice_relation_option: "PAPER",
  invoice_relation_value: null,
  invoice_paper_no: null,
  invoice_paper_title: null,
  invoice_paper_relation_mobile: null,
  invoice_donate_code: "168001",
  invoice_province: null,
  invoice_city: null,
  invoice_region: null,
  invoice_postal_code: null,
  invoice_address: null,
  // 紅利
  coin_discount: 0,
  memo: null,
  cvs_711_shop_id: null,
  cvs_family_shop_id: null,
  cvs_711_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_family_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  uads_address: true,
  uads_cvs_family: true,
  uads_cvs_pcsc: true,
  prom_code_id: null,
  carts: [],
})

const rules = reactive({
  buyer_name: [
    { required: true, message: t('errors.pleaseInput', [t("orders.buyerName")]), trigger: 'blur' },
  ],
  buyer_mobile: [
    { required: true, message: t('errors.pleaseInput', [t("orders.buyerPhone")]), trigger: 'blur' },
  ],
  to_name: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toName")]), trigger: 'blur' },
  ],
  to_mobile: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toPhone")]), trigger: 'blur' },
  ],
  province: [
    { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
  ],
  city: [
    { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
  ],
  region: [
    { required: true, message: t('errors.pleaseSelect', [t("users.region")]), trigger: 'change' },
  ],
  postal_code: [
    { required: true, message: t('errors.pleaseInput', [t("users.postcode")]), trigger: 'blur' },
  ],
  address: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toAddress")]), trigger: 'blur' },
  ],
  cvs_711_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },

  cvs_711_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
  cvs_family_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },
  cvs_family_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
  invoice_type: [
    { required: true, message: t('errors.pleaseSelect', [t("invoices.type")]), trigger: 'change' },
  ],
  invoice_paper_no: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.uniformNumbers")]), trigger: 'blur' },
  ],
  invoice_paper_title: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.companyName")]), trigger: 'blur' },
  ],
  invoice_relation_value: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.carrierCode")]), trigger: 'blur' },
  ],
  invoice_province: [
    { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
  ],
  invoice_city: [
    { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
  ],
  invoice_region: [
    { required: true, message: t('errors.pleaseSelect', [t("users.region")]), trigger: 'change' },
  ],
  invoice_postal_code: [
    { required: true, message: t('errors.pleaseInput', [t("users.postcode")]), trigger: 'blur' },
  ],
  invoice_address: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toAddress")]), trigger: 'blur' },
  ],
})

const state = reactive({
  check_all: true,
  isIndeterminate: false,
  isOuterIsland: {},
  sameHome: true,
  showToInfo: false,
  show: false,
  lang: 'zh-tw',
  currency: null,
  currency_symbol: null,
  currency_point: 0,
  checkout_amount_limit: null,
  free_delivery_amount_limit: null,
  enable_insurance_fees: false,
  invoice_type: 'PAPER',
  countryMap: null,
  discountCode: null,
  // 711門市
  cvs_711_provinces: [],
  cvs_711_distincts: [],
  cvs_711_roads: [],
  cvs_711_shops: [],

  // 全家門市
  cvs_family_provinces: [],
  cvs_family_distincts: [],
  cvs_family_roads: [],
  cvs_family_shops: [],

  invoiceDonateOptions: [
    { label: "(168001) 財團法人ＯＭＧ關懷社會愛心基金會", value: "168001" },
    { label: "(1577) 社團法人中華民國自閉症總會", value: "1577" },
    { label: "(6274) 中華民國災難救援協會", value: "6274" },
  ],
  logistics: [],
})
const handleSameHome = (val) => {
  state.sameHome = val
}

const calcDeliveryFees = (logistic_type) => {
  if (!logistic_type) {
    return 0
  }
  // console.log("calcDeliveryFees: ", logistic_type)
  const logistic = logisticMap.value[logistic_type]
  return logistic._fee_amount
};
const calcDeliveryOutIslandFees = (logistic_type) => {
  if (!logistic_type) {
    return 0
  }
  const logistic = logisticMap.value[logistic_type]
  if (!logistic) {
    return 0
  }
  const rate = logistic.rates.find((rate) => rate.countries.includes(form?.country))
  // console.debug("calcDeliveryOutIslandFees: ", logistic_type, rate)
  if (rate?.fees.length) {
    const fee = rate?.fees[0]
    if (fee?.is_open_outer_island) {
      return fee?.outer_island_fee_amount || 0
    }
  }
  return 0
};

const deleteCart = (cartId) => {
  window.fullPageLoading("show");

  _api_deleteCart(cartId)
    .then(() => {
      const idx = form.carts.findIndex((el) => el.cart_id === cartId)
      const deleteCart = form.carts[idx]

      if (hasGoogleGa.value) {
        gtmTrackers.createEvent("event", "remove_from_cart", {
          items: [
            {
              id: deleteCart.store_product_id,
              name: deleteCart.product_name,
              variant: deleteCart.assort_name,
              quantity: deleteCart.quantity,
              price: deleteCart.sale_price,
              list_position: idx
            }
          ]
        })
      }
      form.carts = form.carts.filter((el) => el.cart_id !== cartId)
        .map((el, carts_idx) => ({ ...el, carts_idx}))
      // form.carts.splice(idx, 1)
    })
    .catch((err) => {
      // console.log(err);
      notificationErrors(err);
    })
    .finally(() => {
      window.fullPageLoading("hide");
      assignCartCount(true)
    });
};

const changeQty = ({cartId, qty}) => {
  if (!ruleFormRef.value) return

  const cart = form.carts.find((elm) => elm.cart_id === cartId)
  const idx = cart.carts_idx
  const validateKey = 'carts.' + idx + '.quantity'
  cart.quantity = qty
  ruleFormRef.value.validateField(validateKey, (valid, fields) => {
    if (valid) {
      window.fullPageLoading("show")

      _api_updateCartQty(cartId, qty)
        .then(() => {

          if (qty === 0) {
            form.carts = form.carts.filter((el) => el.cart_id !== cartId)
              .map((el, carts_idx) => ({ ...el, carts_idx}))
          } else {
            form.carts[idx].quantity = qty
            form.carts[idx].sub_total = qty * form.carts[idx].discounted_price
          }
          // console.log("changeQty: ", form.carts[idx]);
        })
        .catch((err) => {
          console.log(err)
          notificationErrors(err);
        })
        .finally(() => {
          window.fullPageLoading("hide")
          assignCartCount(true)
        })
    } else {
      console.log("change fail: ", fields);
    }
  })
  return
  // console.log("changeQty: ", cartId, qty);
};

const setCountryMap = (country) => {
  if (country) {
    const country_code = country.toLowerCase()
    axios({
      method: 'GET',
      url: "/api/v1/data/iso-3166-ext/"+country_code,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      // console.log(res)
      state.countryMap = res.data
    })
    .catch((err) => {
      return Promise.reject(err.response)
    })
  } else {
    state.countryMap = {}
  }
}

const executeSubmit = async (formEl) => {
  if (!formEl) return
  // console.log("executeSubmit", ruleFormRef.value)
  if (state.sameHome) {
    form.invoice_postal_code = form.postal_code
    form.invoice_province = form.province
    form.invoice_region = form.region
    form.invoice_city = form.city
    form.invoice_address = form.address
  }
  if (!state.showToInfo) {
    form.to_name = form.buyer_name
    form.to_mobile = form.buyer_mobile
  }
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      const createSubmitParams = () => {
        // delete(form.cvs_711_shop_form)
        // delete(form.cvs_family_shop_form)

        let event_group_gift_items = []
        for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
          v.choose_gifts.forEach((gift) => {
            gift.assorts.forEach((assort) => {
              if (assort.quantity > 0) {
                event_group_gift_items.push({
                  'event_group_uuid': v.cart_group_key,
                  'store_product_id': gift.id,
                  'store_assort_id': assort.id,
                  'quantity': assort.quantity,
                })
              }
            })
          })
        }

        return {
          ...form,
          items: form.carts.filter((elm) => elm.checked).map((elm) => ({
              cart_id: elm.cart_id,
              quantity: elm.quantity,
              logistic_type: elm.logistic_type,
          })),
          event_group_gift_items: event_group_gift_items,
          total_price: cartTotal.value,
        }
      }

      const formMap = createSubmitParams()

      // console.log("executeSubmit: ", createSubmitParams())
      // console.log("formMap: ", formMap)
      // 加入常用地址
      if (homeRef.value?.addressRef) {
        // console.debug("homeRef: ", homeRef.value?.isCreate, homeRef.value.uadsState)
        if (homeRef.value?.isCreate) {
          await homeRef.value.addressRef.handleCreate(formMap)
        } else {
          await homeRef.value.addressRef.handleDefault(homeRef.value.uadsState.uads_id)
        }
      }
      if (cvsPcscRef.value?.addressRef) {
        // console.debug("cvsPcscRef: ", cvsPcscRef.value?.isCreate, cvsPcscRef.value.uadsState)
        if (cvsPcscRef.value?.isCreate) {
          await cvsPcscRef.value.addressRef.handleCreate(formMap)
        } else {
          await cvsPcscRef.value.addressRef.handleDefault(cvsPcscRef.value.uadsState.uads_id)
        }
      }
      if (cvsFamilyRef.value?.addressRef) {
        // console.debug("cvsFamilyRef: ", cvsFamilyRef.value?.isCreate, cvsFamilyRef.value.uadsState)
        if (cvsFamilyRef.value?.isCreate) {
          await cvsFamilyRef.value.addressRef.handleCreate(formMap)
        } else {
          await cvsFamilyRef.value.addressRef.handleDefault(cvsFamilyRef.value.uadsState.uads_id)
        }
      }
      // console.log("executeSubmit: ", createSubmitParams())
      // return

      window.fullPageLoading("show")
      _api_checkoutCart(formMap)
        .then(async (res) => {
          if (res.status == 200) {
            // console.log("res: ", res.data)

            clearCartCount()

            // Facebook Pixel Code
            if (hasFacebookPixel.value) {
              await fbqTrackers.createEvent("AddPaymentInfo", res.data.fbq_custom_data);
            }
            // End Facebook Pixel Code
            const redirect_url = res.data.redirect_url
            window.location.assign(redirect_url)
          }
          else if (res.status == 422) {
            if (res.data.errors[0].type == 'CheckoutDataError') {
              const invalid_type = res.data.errors[0].invalid_type
              const invalid_cart_ids = res.data.errors[0].invalid_cart_ids

              if (invalid_type) {
                if (invalid_cart_ids) {
                  res.data.errors[0].invalid_cart_ids.forEach((cartId) => {
                      const idx = form.carts.findIndex((el) => el.cart_id === cartId)
                      const invalidCart = form.carts[idx]
                      const item_name = invalidCart.product_name + " - " + invalidCart.assort_name
                      if (invalid_type == "ITEM_DELETE") {
                        swal.fire(t('carts.invalidItem', item_name), 'error')
                      } else if (invalid_type == 'ITEM_LOWER') {
                        swal.fire(t('carts.removedItem', item_name), 'error')
                      } else if (invalid_type == 'ITEM_OUT_OF_STOCK') {
                        swal.fire(t('carts.inventoryItem', item_name), 'error')
                      } else if (invalid_type == 'EVENT_ITEM_DELETE') {
                        swal.fire('存在異常活動', item_name, 'error')
                      } else if (invalid_type == 'EVENT_ITEM_LOWER') {
                        swal.fire('活動已下架或尚未開始', item_name, 'error')
                      } else {
                        swal.fire(t('carts.abnormalItem', item_name), 'error')
                      }
                      // deleteCart(cartId)
                  });
                }

                if (invalid_type == 'EVENT_GIFT_LOWER') {
                  swal.fire('贈品不存在或已下架', 'error')
                } else if (invalid_type == 'EVENT_GIFT_OUT_OF_STOCK') {
                  swal.fire('贈品庫存不足', 'error')
                } else if (invalid_type == 'EVENT_GIFT_EXCEED_QTY') {
                  swal.fire('已超過可選擇贈品數量', 'error')
                } else if (invalid_type == 'PROM_CODE_DELETE') {
                  swal.fire('存在異常折扣碼', 'error')
                }

              } else {
                swal.fire(res.data.errors[0].msg, 'error')
              }
            } else {
              // swal.fire(ALERT_i18n.value.input_error, 'error')
              notificationErrors(res.data);
            }
          } else {
            // swal.fire(ALERT_i18n.value.submit_error, 'error')
            notificationErrors(res.data);
          }
        })
        .catch((error) => {
          console.log('error ->', error)
          notificationErrors(error);
          // swal.fire(ALERT_i18n.value.submit_error, 'error')
        })
        .finally(() => {
          window.fullPageLoading("hide")
        })

    } else {
      for (const key in fields) {
        if (["buyer_mobile", "buyer_name"].includes(key)) {
          formEl.scrollToField("buyer-info")
          break
        }
        else if (["to_name", "to_mobile"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["province", "city", "region", "postal_code", "address"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["cvs_711_shop_form.province", "cvs_711_shop_form.distinct", "cvs_711_shop_form.road", "cvs_711_shop_id"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["cvs_family_shop_form.province", "cvs_family_shop_form.distinct", "cvs_family_shop_form.road", "cvs_family_shop_id"].includes(key)) {
          formEl.scrollToField("to-info")
          break
        }
        else if (["invoice_relation_value", "invoice_paper_no", "invoice_paper_title"].includes(key)) {
          formEl.scrollToField("invoice")
          break
        }
        else {
          // console.log('error submit!', key)
          formEl.scrollToField(Object.keys(fields)[0])
          console.log('error submit!', fields)
          break
        }
      }
    }
  })
}

const initTrackersEvents = () => {
  const val = props.modelValue
  if (!val?.trackers) {
    return
  }
  if (val.trackers?.fbq_pixel_ids && !!val.trackers.fbq_pixel_ids.length) {
    fbqTrackers.createEvent("InitiateCheckout", {
      content_type: "product",
      contents: val.carts.map((cart) => ({ id: cart.store_product_id, quantity: cart.quantity })),
      currency: val.currency,
      num_items: val.carts.length,
      value: cartTotal.value,
    })
  }

  if (val.trackers?.ga_ids && !!val.trackers.ga_ids.length) {
    gtmTrackers.createEvent("event", "begin_checkout", {
      currency: val.currency,
      value: cartTotal.value,
      items: val.carts.map((cart, i) => (
        {
          // item_id: cart.store_product_id,
          // item_name: cart.product_name,
          // item_variant: cart.assort_name,
          id: cart.store_product_id,
          name: cart.product_name,
          currency: val.currency,
          variant: cart.assort_name,
          quantity: cart.quantity,
          price: cart.sale_price,
          // index: i+1,
        }
      )),
    })
  }
}

const promotionCodeDiscount = computed(() => state.discountCode ? state.discountCode.amount : 0)
const handleDiscountCode = (item) => {
  // console.log('state.discountCode', item)
  state.discountCode = item
}

// const debounce = _.debounce(initTrackersEvents, 3000);

onMounted(() => {
  // nextTick(() => debounce())
  initTrackersEvents()
})

// $(function () {
  // initTrackersEvents()
  // console.debug("function")
// })

watch(
  () => props.modelValue,
  (val) => {
    // console.log("watch modelValue: ", val)
    if (val) {
      data.value = val
      setCountryMap(data.value.country);

      form.carts = val.carts.map((cart, carts_idx) => {
        let is_valid = false
        if (cart.status == 'shelves' && cart.quantity <= cart.max_order_quantity) {
          is_valid = true
        }
        return {
          ...cart,
          is_valid,
          carts_idx,
          checked: is_valid,
          logistic_type: cart.available_logistic_types ? cart.available_logistic_types[0] : null,
        }
      })

      form.buyer_name = val.login_user.name
      form.buyer_mobile = val.login_user.mobile
      form.buyer_email = val.login_user.email
      form.to_name = val.login_user.name
      form.to_mobile = val.login_user.mobile
      form.to_email = val.login_user.email
      form.country = val.country
      // 超過兩種物流，預設強制使用預付金流
      if (getLogisticTypess.value.length > 1 && !!prePayOpts.value.length) {
        form.payment_type = prePayOpts.value[0]
      }

      state.currency = val.currency
      state.currency_symbol = val.currency_symbol
      state.currency_point = val.currency_point
      state.checkout_amount_limit = val.checkout_amount_limit
      state.free_delivery_amount_limit = val.free_delivery_amount_limit
      state.enable_insurance_fees = val.enable_insurance_fees
      state.invoice_type = val.invoice_type
      state.logistics = val.logistics
    }
  },
  { deep: true, immediate: true }
)

watch(
  () => availablePaymentTypes.value,
  (v) => {
    if (v.length) {
      if (v.findIndex((el) => el.type == form.payment_type) == -1) {
        form.payment_type = v[0].type
      }
    } else {
      form.payment_type = null
    }
  },
  { deep: true, immediate: true }
)

</script>